// extracted by mini-css-extract-plugin
export default {"container":"CertificateEditor_container__EXdje","img":"CertificateEditor_img__8M91Q","uploadLabel":"CertificateEditor_uploadLabel__9d73Y"};